import 'bootstrap/dist/css/bootstrap.css';
import './index.scss';
import 'react-widgets/lib/scss/react-widgets.scss';
import "react-datepicker/dist/react-datepicker.css"


import * as React from 'react';
import * as ReactDOM from 'react-dom';
import * as hist from 'history';
import * as serviceWorker from './registerServiceWorker';
import { Provider } from 'mobx-react';
import './common/DateExtensions';
import './common/ArraysExtensions';
import './common/StringExtensions';
import { default as jwtDecode } from "jwt-decode";

import { eraseCookie, createCookie, getCookie } from './common/Cookies';
import { RootStore } from './stores';

import { NotificationStore, NotificationLevel } from './stores/NotificationStore';
import { RouterStore, syncHistoryWithStore } from 'mobx-react-router';
import { Router } from 'react-router';

import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";

import {
    STORE_ROOT, STORE_AUTH, STORE_COMMON, STORE_NOTIFICATION, STORE_CREATE_EDIT_CUSTOMER_ORDER, STORE_CUSTOMERS,
    STORE_CUSTOMER_ORDERS, STORE_REPORT1, STORE_REJECTIONS, STORE_DEMANDS, STORE_ACCEPTANCES, STORE_PRINT, STORE_SEARCH_HISTORY, STORE_KASSES, STORE_ORDERS_NOTIFICATION, STORE_CDEK, STORE_REPORT2, STORE_VIN_QUERIES, STORE_REPORT3, STORE_USERS
} from './constants';
import Routes from './Routes';

import { library } from '@fortawesome/fontawesome-svg-core'
import {
    faStroopwafel, faSignOutAlt, faPlus, faTrash, faSortUp, faSortDown, faBars, faChartLine, faEdit, faChevronRight, faChevronLeft,
    faChevronDown, faLongArrowAltDown, faFileExport, faFileExcel, faArrowLeft, faTimes, faAngleDoubleDown, faAngleDown,
    faMinus, faSyncAlt, faSave, faSearch, faStepBackward, faStepForward, faCaretDown, faSpinner, faCheck, faEye, faPrint, faSms, faMobileAlt, faHistory, faExclamation, faMoneyBillWave, faCreditCard, faFileSignature, faClock, faAngleUp, faPen, faArrowUp
} from '@fortawesome/free-solid-svg-icons'

library.add(faStroopwafel, faSignOutAlt, faPlus, faMinus, faTrash, faSortUp, faSortDown, faBars, faChartLine, faEdit, faChevronRight,
    faChevronLeft, faChevronDown, faLongArrowAltDown,
    faFileExport, faFileExcel, faArrowLeft, faTimes, faAngleDoubleDown, faAngleDown, faAngleUp, faSyncAlt, faSave, faSearch, faStepBackward, faStepForward,
    faCaretDown, faSpinner, faCheck, faEye, faPrint, faSms, faMobileAlt, faHistory, faExclamation, faMoneyBillWave, faCreditCard, faFileSignature, faClock, faPen, faArrowUp);


Sentry.init({
    dsn: "https://939b3de394e247d28cfd490813b66f54@o1174794.ingest.sentry.io/6271089",
    integrations: [new BrowserTracing()],
    release: "abteka.bo@28.03.22-1",
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
    attachStacktrace: true
});


const notificationStore = new NotificationStore();
const rootStore = new RootStore(notificationStore, window.localStorage, window.document, window);

const browserHistory = hist.createBrowserHistory();
const routingStore = new RouterStore();

const history = syncHistoryWithStore(browserHistory, routingStore);

const tokenCookie = getCookie("jwt") as string;
const token = tokenCookie;
let roles = [];
if (token != undefined && token.length > 0 && token.split(".").length == 3) {
    eraseCookie("jwt");
    createCookie("jwt", token, 1);
    const payload = token.split(".")[1];
    const payloadObj: any = jwtDecode(payload, { header: true });
    roles = payloadObj["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"];
    const authStore = rootStore[STORE_AUTH];
    authStore.token = token;
    authStore.name = payloadObj["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/givenname"];
    authStore.deliveryPointName = payloadObj["DeliveryPointName"];
    authStore.roles = roles;

}


const stores = {
    [STORE_ROOT]: rootStore,
    [STORE_AUTH]: rootStore.authStore,
    [STORE_COMMON]: rootStore.commonStore,
    routing: routingStore,
    [STORE_NOTIFICATION]: notificationStore,
    [STORE_CREATE_EDIT_CUSTOMER_ORDER]: rootStore.createEditCustomerOrderStore,
    [STORE_CUSTOMERS]: rootStore.customersStore,
    [STORE_CUSTOMER_ORDERS]: rootStore.customerOrdersStore,
    [STORE_REJECTIONS]: rootStore.rejectionsStore,
    [STORE_REPORT1]: rootStore.report1Store,
    [STORE_REPORT2]: rootStore.report2Store,
    [STORE_REPORT3]: rootStore.report3Store,
    [STORE_DEMANDS]: rootStore.demandsStore,
    [STORE_ACCEPTANCES]: rootStore.acceptancesStore,
    [STORE_PRINT]: rootStore.printStore,
    [STORE_SEARCH_HISTORY]: rootStore.searchHistoryStore,
    [STORE_KASSES]: rootStore.kassesStore,
    [STORE_ORDERS_NOTIFICATION]: rootStore.ordersNotificationStore,
    [STORE_CDEK]: rootStore.cdekStore,
    [STORE_USERS]: rootStore.usersStore,
    [STORE_VIN_QUERIES]: rootStore.vinQueriesStore,
}

rootStore.ordersNotificationStore.InitNewOrdersNotifications();




ReactDOM.render((
    <Provider {...stores}>
        <Router history={history}>
            <Routes />
            {/* <Route exact path='/' component={Home} /> */}
            {/* <div>Test</div> */}
        </Router>
    </Provider>
), document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
